
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"

// To use more complicated format
// see https://day.js.org/docs/en/plugin/advanced-format for more details
dayjs.extend(advancedFormat)

// https://day.js.org/docs/en/plugin/custom-parse-format
dayjs.extend(customParseFormat)

export default dayjs
